import React from "react";
import TlkTable from "../../tlelrik/table/tlkTable";
import services from "../../../services";
import queryString from "query-string";
import moment from "moment";
import TabsContaDetailsContainer from "../../ContaModule/Tabs/TabsContaDetailsContainer";

const groupfield = [
    // { field: "Número de registo" }

    //{ field: "Entreposto" },
    // { field: 'Concelho' },
    // { field: 'Freguesia' },
];

const columnKeyMap = {
    numeroRegisto: "Número de registo",
    numeroProcessoLims: "Número de processo LIMS",
    anoProduto: "Ano do produto",
    mencaoComplementar: "Menção complementar",
    mencaoFacultativa: "Menção facultativa",
    mencaoObrigatoria: "Menção qualitativa",
    nivelQualitativo: "Nível qualitativo",
    cor: "Cor",
    grauDocura: "Grau de doçura",
    madeira: "Madeira",
    dataCriado: "Data criado",
    validadeRegisto: "Validade do registo"
};

const dateFormat = "DD-MM-YYYY HH:mm:ss";
const actionbuttons = {};

const filterValue = {
    numeroRegisto: null
};

class RegistoTable extends React.Component {
    constructor() {
        super();

        this.state = {
            loaded: false,
            data: [],
            totalCount: 0,
            columnList: [],
            filters: {
                Filters: filterValue,
                FiltersIn: null,
                FiltersLike: null,
                SortBy: "",
                IsSortTypeDESC: true,
                IsPagination: false,
                Page: 2,
                PageSize: 2,
            },
        };
    }

    componentDidMount() {
        (async () => {
            const queryParams = queryString.parse(this.props.location.search);
            const filters = {
                ...this.state.filters,
                Filters: {
                    ...this.state.filters.Filters,
                    numeroRegisto: queryParams.nrReg
                },
            };
            this.setState({
                numeroRegisto: queryParams.numeroRegisto,
            });
            const response = await services.apiCall.requestApi(
                "Registo/GetAll",
                filters,
                "post"
            );
            // const columnList = Object.keys(columnKeyMap).map((key) => ({
            //     field: columnKeyMap[key],
            //     columnMenuType: "checkbox",
            // }));

            var columnList = [];

            Object.keys(columnKeyMap).forEach(e => {
                if (e == "dataCriado") {
                    columnList.push({ field: columnKeyMap[e], columnMenuType: "number" });
                }
                else {
                    columnList.push({ field: columnKeyMap[e], columnMenuType: "checkbox" });
                }
            });

            if (response) {
                const data = response.map((entity, index) => ({
                    ...entity,
                    ...Object.keys(columnKeyMap).map((key) => {
                        if (
                            key === "valorOperacaoCapacidadeVenda" ||
                            key === "acumuladoDisponivel"
                        ) {
                            entity[columnKeyMap[key]] = services.money.format(entity[key]) || "0";
                        }
                        else if (key === "dataCriado") {
                            entity[columnKeyMap[key]] = moment(
                                entity.dataOperacao
                            ).format(dateFormat)
                        }
                        else {
                            entity[columnKeyMap[key]] = entity[key] || "NA";
                        }
                    }),
                    selected: false,
                }));
                this.setState(() => ({
                    data,
                    columnList,
                    totalCount: window.localStorage.getItem("table_total"),
                    loaded: true,
                }));
            } else {
                this.setState(() => ({
                    data: response,
                    totalCount: 0,
                    columnList,
                    loaded: false,
                }));
            }
        })();
    }

    selectionChange(selection) {
        const data = [...this.state.data].map((item) => {
            if (
                selection.dataItem.codInstalacaoVinica ===
                item.codInstalacaoVinica
            ) {
                // TODO: Ask @Dart for the unique key to use here
                return { ...item, selected: true };
            } else {
                return { ...item, selected: false };
            }
        });
        this.setState({ data }, async () => {
            const queryParams = queryString.stringify({
                ...queryString.parse(this.props.location.search),
                installationId: 0,
            });
            this.props.history.push(
                `/conta_corrente/accounts_view?${queryParams}`
            );
        });
    }



    accountDetailsToPass = () => {
        const params = queryString.parse(this.props.location.search);
        console.log("params9999 ", params);
        let accountDetails = {};
        accountDetails["accountNumber"] = params.ncc || "NA";
        accountDetails["accounttype"] = params.tdc || "NA";
        accountDetails["accountProduct"] = params.pr || "NA";
        accountDetails["saldoGranel"] = params.sldG || "NA";
        accountDetails["saldoApto"] = params.sldA || "NA";
        accountDetails["saldoEngarrafado"] = params.sldE || "NA";
        accountDetails["accountTotal"] = params.sa || "NA";
        accountDetails["tipoConta"] = params.tdc || "NA";
        return accountDetails;
    };

    entityDetailData = (data) => {
        this.setState({ entityDetail: data })
    }

    render() {
        return (
            <>
                {
                    <>
                        <div className="mt-4">
                            <TabsContaDetailsContainer
                                accountDetails={this.accountDetailsToPass()}
                                location={this.props.location}
                                match={this.props.match}
                                entityDetailData={(data) => this.entityDetailData(data)}
                            />
                            <div className="table-section custom-k-grid pt-3">
                                <div className="table-responsive">
                                    {this.state.loaded && (
                                        <>
                                            <span>
                                                A pesquisa retornou {this.state.totalCount} registos
                                            </span>
                                            <TlkTable
                                                date={new Date()}
                                                list={this.state.data}
                                                modulename={"Registo"}
                                                notAction={true}
                                                // notGroup={true}
                                                columnlist={this.state.columnList}
                                                ActionPerform={(action, id) =>
                                                    this.ActionPerform(action, id)
                                                }
                                                groupfield={groupfield}
                                            //toolbarHTML={ this.getToolbarHtml() }
                                            />
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                }
            </>
        );
    }
}

export default RegistoTable;
